var items = {
  "block.minecraft.air": "airea",
  "block.minecraft.stone": "harria",
  "block.minecraft.granite": "granitoa",
  "block.minecraft.polished_granite": "txartatutako granitoa",
  "block.minecraft.diorite": "diorita",
  "block.minecraft.polished_diorite": "txartatutako diorita",
  "block.minecraft.andesite": "andesita",
  "block.minecraft.polished_andesite": "txartatutako andesita",
  "block.minecraft.grass_block": "belar blokea",
  "block.minecraft.dirt": "lurra",
  "block.minecraft.coarse_dirt": "lur trokatsua",
  "block.minecraft.podzol": "podsola",
  "block.minecraft.crimson_nylium": "nezelio gorrimina",
  "block.minecraft.warped_nylium": "nezelio okertua",
  "block.minecraft.cobblestone": "arroka",
  "block.minecraft.oak_planks": "haritz oholak",
  "block.minecraft.spruce_planks": "izei oholak",
  "block.minecraft.birch_planks": "urki oholak",
  "block.minecraft.jungle_planks": "oihan oholak",
  "block.minecraft.acacia_planks": "akazia oholak",
  "block.minecraft.dark_oak_planks": "haritz ilun oholak",
  "block.minecraft.crimson_planks": "ohol gorriminak",
  "block.minecraft.warped_planks": "ohol okertuak",
  "block.minecraft.oak_sapling": "haritz kimetza",
  "block.minecraft.spruce_sapling": "izei kimetza",
  "block.minecraft.birch_sapling": "urki kimetza",
  "block.minecraft.jungle_sapling": "oihan kimetza",
  "block.minecraft.acacia_sapling": "akazia kimetza",
  "block.minecraft.dark_oak_sapling": "haritz ilun kimetza",
  "block.minecraft.bedrock": "arroka-mantua",
  "block.minecraft.sand": "harea",
  "block.minecraft.red_sand": "hare-gorria",
  "block.minecraft.gravel": "legarra",
  "block.minecraft.gold_ore": "urrezko mea",
  "block.minecraft.iron_ore": "burdinazko mea",
  "block.minecraft.coal_ore": "ikatzezko mea",
  "block.minecraft.nether_gold_ore": "netherreko urrezko mea",
  "block.minecraft.oak_log": "haritz enborra",
  "block.minecraft.spruce_log": "izei enborra",
  "block.minecraft.birch_log": "urki enborra",
  "block.minecraft.jungle_log": "oihan enborra",
  "block.minecraft.acacia_log": "akazia enborra",
  "block.minecraft.dark_oak_log": "haritz ilun enborra",
  "block.minecraft.crimson_stem": "zurtoin gorrimina",
  "block.minecraft.warped_stem": "zurtoin okertua",
  "block.minecraft.stripped_oak_log": "azalik gabeko haritz enborra",
  "block.minecraft.stripped_spruce_log": "azalik gabeko izei enborra",
  "block.minecraft.stripped_birch_log": "azalik gabeko urki enborra",
  "block.minecraft.stripped_jungle_log": "azalik gabeko oihan enborra",
  "block.minecraft.stripped_acacia_log": "azalik gabeko akazia enborra",
  "block.minecraft.stripped_dark_oak_log": "azalik gabeko haritz ilun enborra",
  "block.minecraft.stripped_crimson_stem": "azalik gabeko zurtoin gorrimina",
  "block.minecraft.stripped_warped_stem": "azalik gabeko zurtoin okertua",
  "block.minecraft.stripped_oak_wood": "azalik gabeko haritz egurra",
  "block.minecraft.stripped_spruce_wood": "azalik gabeko izei egurra",
  "block.minecraft.stripped_birch_wood": "azalik gabeko urki egurra",
  "block.minecraft.stripped_jungle_wood": "azalik gabeko oihan egurra",
  "block.minecraft.stripped_acacia_wood": "azalik gabeko akazia egurra",
  "block.minecraft.stripped_dark_oak_wood": "azalik gabeko haritz ilun egurra",
  "block.minecraft.stripped_crimson_hyphae": "azalik gabeko hifa gorrimina",
  "block.minecraft.stripped_warped_hyphae": "azalik gabeko hifa okertua",
  "block.minecraft.oak_wood": "haritz egurra",
  "block.minecraft.spruce_wood": "izei egurra",
  "block.minecraft.birch_wood": "urki egurra",
  "block.minecraft.jungle_wood": "oihan egurra",
  "block.minecraft.acacia_wood": "akazia egurra",
  "block.minecraft.dark_oak_wood": "haritz ilun egurra",
  "block.minecraft.crimson_hyphae": "hifa gorrimina",
  "block.minecraft.warped_hyphae": "hifa okertua",
  "block.minecraft.oak_leaves": "haritz hostoak",
  "block.minecraft.spruce_leaves": "izei hostoak",
  "block.minecraft.birch_leaves": "urki hostoak",
  "block.minecraft.jungle_leaves": "oihan hostoak",
  "block.minecraft.acacia_leaves": "akazia hostoak",
  "block.minecraft.dark_oak_leaves": "haritz ilun hostoak",
  "block.minecraft.sponge": "belakia",
  "block.minecraft.wet_sponge": "belaki bustia",
  "block.minecraft.glass": "kristala",
  "block.minecraft.lapis_ore": "lapis lazulizko mea",
  "block.minecraft.lapis_block": "lapis lazulizko blokea",
  "block.minecraft.dispenser": "dispentsagailua",
  "block.minecraft.sandstone": "hareharri",
  "block.minecraft.chiseled_sandstone": "hareharri zizelkatua",
  "block.minecraft.cut_sandstone": "hareharri moztua",
  "block.minecraft.note_block": "nota blokea",
  "block.minecraft.powered_rail": "propultsagailudun erraila",
  "block.minecraft.detector_rail": "detektagailudun erraila",
  "block.minecraft.sticky_piston": "pistoi itsaskorra",
  "block.minecraft.cobweb": "armiarma-sarea",
  "block.minecraft.grass": "belarra",
  "block.minecraft.fern": "iratzea",
  "block.minecraft.dead_bush": "zuhaixka lehorra",
  "block.minecraft.seagrass": "itsas belarra",
  "block.minecraft.sea_pickle": "itsasoko eskabetxea",
  "block.minecraft.piston": "pistoia",
  "block.minecraft.white_wool": "artile zuria",
  "block.minecraft.orange_wool": "artile laranja",
  "block.minecraft.magenta_wool": "artile magenta",
  "block.minecraft.light_blue_wool": "artile urdin argia",
  "block.minecraft.yellow_wool": "artile horia",
  "block.minecraft.lime_wool": "artile lima",
  "block.minecraft.pink_wool": "artile arrosa",
  "block.minecraft.gray_wool": "artile grisa",
  "block.minecraft.light_gray_wool": "artile gris argia",
  "block.minecraft.cyan_wool": "artile ziana",
  "block.minecraft.purple_wool": "artile morea",
  "block.minecraft.blue_wool": "artile urdina",
  "block.minecraft.brown_wool": "artile marroia",
  "block.minecraft.green_wool": "artile berdea",
  "block.minecraft.red_wool": "artile gorria",
  "block.minecraft.black_wool": "artile beltza",
  "block.minecraft.dandelion": "txikoria-belar",
  "block.minecraft.poppy": "mitxoleta",
  "block.minecraft.blue_orchid": "orkide urdina",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "bluet urdin argia",
  "block.minecraft.red_tulip": "tulipa gorria",
  "block.minecraft.orange_tulip": "tulipa laranja",
  "block.minecraft.white_tulip": "tulipa zuria",
  "block.minecraft.pink_tulip": "idi-bihotz arrosa",
  "block.minecraft.oxeye_daisy": "sanjoan-lorea",
  "block.minecraft.cornflower": "nabar-lorea",
  "block.minecraft.lily_of_the_valley": "mugeta",
  "block.minecraft.wither_rose": "wither arrosa",
  "block.minecraft.brown_mushroom": "perretxiko marroia",
  "block.minecraft.red_mushroom": "onddo gorria",
  "block.minecraft.crimson_fungus": "onddo gorrimina",
  "block.minecraft.warped_fungus": "onddo okertua",
  "block.minecraft.crimson_roots": "sustrai gorriminak",
  "block.minecraft.warped_roots": "sustrai okertuak",
  "block.minecraft.nether_sprouts": "netherreko ernamuinak",
  "block.minecraft.weeping_vines": "igokari negartiak",
  "block.minecraft.twisting_vines": "igokari okerra",
  "block.minecraft.sugar_cane": "azukre kanabera",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "banbua",
  "block.minecraft.gold_block": "urrezko blokea",
  "block.minecraft.iron_block": "burdinazko blokea",
  "block.minecraft.oak_slab": "haritzezko lauza",
  "block.minecraft.spruce_slab": "izeizko lauza",
  "block.minecraft.birch_slab": "urkizko lauza",
  "block.minecraft.jungle_slab": "oihanezko lauza",
  "block.minecraft.acacia_slab": "akaziazko lauza",
  "block.minecraft.dark_oak_slab": "haritz ilunezko lauza",
  "block.minecraft.crimson_slab": "lauza gorrimina",
  "block.minecraft.warped_slab": "lauza okertua",
  "block.minecraft.stone_slab": "harrizko lauza",
  "block.minecraft.smooth_stone_slab": "harri leunezko lauza",
  "block.minecraft.sandstone_slab": "hareharrizko lauza",
  "block.minecraft.cut_sandstone_slab": "moztutako hareharrizko lauza",
  "block.minecraft.petrified_oak_slab": "harritutako haritzezko lauza",
  "block.minecraft.cobblestone_slab": "arrokazko lauza",
  "block.minecraft.brick_slab": "adreiluzko lauza",
  "block.minecraft.stone_brick_slab": "harrizko adreiluzko lauza",
  "block.minecraft.nether_brick_slab": "netherreko adreiluzko lauza",
  "block.minecraft.quartz_slab": "kuartzozko lauza",
  "block.minecraft.red_sandstone_slab": "hareharri gorrizko lauza",
  "block.minecraft.cut_red_sandstone_slab": "moztutako hareharri gorrizko lauza",
  "block.minecraft.purpur_slab": "purpur lauza",
  "block.minecraft.prismarine_slab": "prismarinazko lauza",
  "block.minecraft.prismarine_brick_slab": "prismarinazko adreiluzko lauza",
  "block.minecraft.dark_prismarine_slab": "prismarina ilunezko lauza",
  "block.minecraft.smooth_quartz": "kuartzo leunezko blokea",
  "block.minecraft.smooth_red_sandstone": "hareharri gorri leuna",
  "block.minecraft.smooth_sandstone": "hareharri leuna",
  "block.minecraft.smooth_stone": "harri leuna",
  "block.minecraft.bricks": "adreiluak",
  "block.minecraft.tnt": "dinamita",
  "block.minecraft.bookshelf": "liburu-apalategia",
  "block.minecraft.mossy_cobblestone": "arroka goroldiotsua",
  "block.minecraft.obsidian": "obsidiana",
  "block.minecraft.torch": "argi-zuzia",
  "block.minecraft.end_rod": "end barra",
  "block.minecraft.chorus_plant": "koral landarea",
  "block.minecraft.chorus_flower": "koral lorea",
  "block.minecraft.purpur_block": "purpura blokea",
  "block.minecraft.purpur_pillar": "purpur pilarea",
  "block.minecraft.purpur_stairs": "purpurezko eskailerak",
  "block.minecraft.spawner": "sortzailea",
  "block.minecraft.oak_stairs": "haritzezko eskailerak",
  "block.minecraft.chest": "kutxa",
  "block.minecraft.diamond_ore": "diamantezko mea",
  "block.minecraft.diamond_block": "diamantezko blokea",
  "block.minecraft.crafting_table": "lan-mahaia",
  "block.minecraft.farmland": "saila",
  "block.minecraft.furnace": "labea",
  "block.minecraft.ladder": "zurubia",
  "block.minecraft.rail": "erraila",
  "block.minecraft.cobblestone_stairs": "arrokazko eskailerak",
  "block.minecraft.lever": "palanka",
  "block.minecraft.stone_pressure_plate": "harrizko presio plaka",
  "block.minecraft.oak_pressure_plate": "haritzezko presio plaka",
  "block.minecraft.spruce_pressure_plate": "izeizko presio plaka",
  "block.minecraft.birch_pressure_plate": "urkizko presio plaka",
  "block.minecraft.jungle_pressure_plate": "oihanezko presio plaka",
  "block.minecraft.acacia_pressure_plate": "akaziazko presio plaka",
  "block.minecraft.dark_oak_pressure_plate": "haritz ilunezko presio plaka",
  "block.minecraft.crimson_pressure_plate": "presio plaka gorrimina",
  "block.minecraft.warped_pressure_plate": "presio plaka okertua",
  "block.minecraft.polished_blackstone_pressure_plate": "txartatutako harribeltzezko presio plaka",
  "block.minecraft.redstone_ore": "redstonezko mea",
  "block.minecraft.redstone_torch": "redstone-zuzia",
  "block.minecraft.snow": "elurra",
  "block.minecraft.ice": "izotza",
  "block.minecraft.snow_block": "elur blokea",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "buztina",
  "block.minecraft.jukebox": "musika kaxa",
  "block.minecraft.oak_fence": "haritzezko hesia",
  "block.minecraft.spruce_fence": "izeizko hesia",
  "block.minecraft.birch_fence": "urkizko hesia",
  "block.minecraft.jungle_fence": "ohianezko hesia",
  "block.minecraft.acacia_fence": "akaziazko hesia",
  "block.minecraft.dark_oak_fence": "haritz ilunezko hesia",
  "block.minecraft.crimson_fence": "hesi gorrimina",
  "block.minecraft.warped_fence": "hesi okertua",
  "block.minecraft.pumpkin": "kalabaza",
  "block.minecraft.carved_pumpkin": "kalabaza tailatua",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "arima harea",
  "block.minecraft.soul_soil": "arima-lurra",
  "block.minecraft.basalt": "basaltoa",
  "block.minecraft.polished_basalt": "txartatutako basaltoa",
  "block.minecraft.soul_torch": "arima-zuzia",
  "block.minecraft.glowstone": "argi-harria",
  "block.minecraft.jack_o_lantern": "kalabaza linterna",
  "block.minecraft.oak_trapdoor": "haritzezko tranpola",
  "block.minecraft.spruce_trapdoor": "izeizko tranpola",
  "block.minecraft.birch_trapdoor": "urkizko tranpola",
  "block.minecraft.jungle_trapdoor": "oihanezko tranpola",
  "block.minecraft.acacia_trapdoor": "akaziazko tranpola",
  "block.minecraft.dark_oak_trapdoor": "haritz ilunezko tranpola",
  "block.minecraft.crimson_trapdoor": "tranpola gorrimina",
  "block.minecraft.warped_trapdoor": "tranpola okertua",
  "block.minecraft.infested_stone": "izurritutako harria",
  "block.minecraft.infested_cobblestone": "izurritutako arroka",
  "block.minecraft.infested_stone_bricks": "izurritutako harrizko adreiluak",
  "block.minecraft.infested_mossy_stone_bricks": "izurritutako harri goroldiotsuzko adreiluak",
  "block.minecraft.infested_cracked_stone_bricks": "izurritutako harrizko adreilu pitzatuak",
  "block.minecraft.infested_chiseled_stone_bricks": "izurritutako harrizko adreilu zizelkatuak",
  "block.minecraft.stone_bricks": "harrizko adreiluak",
  "block.minecraft.mossy_stone_bricks": "harri goroldiotsuzko adreiluak",
  "block.minecraft.cracked_stone_bricks": "harrizko adreilu pitzatuak",
  "block.minecraft.chiseled_stone_bricks": "harrizko adreilu zizelkatuak",
  "block.minecraft.brown_mushroom_block": "perretxiko marroizko blokea",
  "block.minecraft.red_mushroom_block": "perretxiko gorrizko blokea",
  "block.minecraft.mushroom_stem": "perretxiko zurtoina",
  "block.minecraft.iron_bars": "burdinazko barrak",
  "block.minecraft.chain": "katea",
  "block.minecraft.glass_pane": "kristalezko panela",
  "block.minecraft.melon": "meloia",
  "block.minecraft.vine": "igokaria",
  "block.minecraft.oak_fence_gate": "haritzezko hesi atea",
  "block.minecraft.spruce_fence_gate": "izeizko hesi atea",
  "block.minecraft.birch_fence_gate": "urkizko hesi atea",
  "block.minecraft.jungle_fence_gate": "ohianezko hesi atea",
  "block.minecraft.acacia_fence_gate": "akaziazko hesi atea",
  "block.minecraft.dark_oak_fence_gate": "haritz ilunezko hesi atea",
  "block.minecraft.crimson_fence_gate": "hesi ate gorrimina",
  "block.minecraft.warped_fence_gate": "hesi ate okertua",
  "block.minecraft.brick_stairs": "adreiluzko eskailerak",
  "block.minecraft.stone_brick_stairs": "harri adreiluzko eskailerak",
  "block.minecraft.mycelium": "mizelioa",
  "block.minecraft.lily_pad": "igebelarra",
  "block.minecraft.nether_bricks": "netherreko adreiluak",
  "block.minecraft.cracked_nether_bricks": "netherreko adreilu pitzatuak",
  "block.minecraft.chiseled_nether_bricks": "netherreko adreilu zizelkatuak",
  "block.minecraft.nether_brick_fence": "netherreko adreiluzko hesia",
  "block.minecraft.nether_brick_stairs": "netherreko adreiluzko eskailerak",
  "block.minecraft.enchanting_table": "sorginkeria mahaia",
  "block.minecraft.end_portal_frame": "amaierako munduko markoa",
  "block.minecraft.end_stone": "amaierako harria",
  "block.minecraft.end_stone_bricks": "amaierako harrizko adreilua",
  "block.minecraft.dragon_egg": "dragoiaren arrautza",
  "block.minecraft.redstone_lamp": "redstone-lanpara",
  "block.minecraft.sandstone_stairs": "hareharrizko eskailerak",
  "block.minecraft.emerald_ore": "esmeraldazko mea",
  "block.minecraft.ender_chest": "enderkutxa",
  "block.minecraft.tripwire_hook": "segadaren lotura",
  "block.minecraft.emerald_block": "esmeralda blokea",
  "block.minecraft.spruce_stairs": "izeizko eskailerak",
  "block.minecraft.birch_stairs": "urkizko eskailerak",
  "block.minecraft.jungle_stairs": "oihanezko eskailerak",
  "block.minecraft.crimson_stairs": "eskailera gorriminak",
  "block.minecraft.warped_stairs": "eskailera okertuak",
  "block.minecraft.command_block": "agindu blokea",
  "block.minecraft.beacon": "faro",
  "block.minecraft.cobblestone_wall": "arrokazko horma",
  "block.minecraft.mossy_cobblestone_wall": "arroka goroldiotsuzko horma",
  "block.minecraft.brick_wall": "adreiluzko pareta",
  "block.minecraft.prismarine_wall": "prismarinazko pareta",
  "block.minecraft.red_sandstone_wall": "hareharri gorrizko pareta",
  "block.minecraft.mossy_stone_brick_wall": "harri goroldiotsu adreiluzko pareta",
  "block.minecraft.granite_wall": "granito horma",
  "block.minecraft.stone_brick_wall": "harri adreiluzko pareta",
  "block.minecraft.nether_brick_wall": "netherreko adreiluzko horma",
  "block.minecraft.andesite_wall": "andesitazko pareta",
  "block.minecraft.red_nether_brick_wall": "netherreko adreilu gorrizko horma",
  "block.minecraft.sandstone_wall": "hareharri pareta",
  "block.minecraft.end_stone_brick_wall": "amaierako harri adreiluzko horma",
  "block.minecraft.diorite_wall": "dioritazko horma",
  "block.minecraft.blackstone_wall": "harribeltzezko horma",
  "block.minecraft.polished_blackstone_wall": "txartatutako harribeltzezko horma",
  "block.minecraft.polished_blackstone_brick_wall": "txartatutako harribeltzezko adreiluzko horma",
  "block.minecraft.stone_button": "harrizko botoia",
  "block.minecraft.oak_button": "haritzezko botoia",
  "block.minecraft.spruce_button": "izeizko botoia",
  "block.minecraft.birch_button": "urkizko botoia",
  "block.minecraft.jungle_button": "oihanezko botoia",
  "block.minecraft.acacia_button": "akaziazko botoia",
  "block.minecraft.dark_oak_button": "haritz ilunezko botoia",
  "block.minecraft.crimson_button": "botoi gorrimina",
  "block.minecraft.warped_button": "botoi okertua",
  "block.minecraft.polished_blackstone_button": "txartatutako harribeltzezko botoia",
  "block.minecraft.anvil": "ingude",
  "block.minecraft.chipped_anvil": "kaltetutako ingudea",
  "block.minecraft.damaged_anvil": "ondatutako ingudea",
  "block.minecraft.trapped_chest": "tranpadun kutxa",
  "block.minecraft.light_weighted_pressure_plate": "presio plaka arina",
  "block.minecraft.heavy_weighted_pressure_plate": "presio plaka astuna",
  "block.minecraft.daylight_detector": "eguzki argi sentsorea",
  "block.minecraft.redstone_block": "redstonezko blokea",
  "block.minecraft.nether_quartz_ore": "netherreko kuartzozko mea",
  "block.minecraft.hopper": "kalapatxa",
  "block.minecraft.chiseled_quartz_block": "kuartzo zizelkatua",
  "block.minecraft.quartz_block": "kuartzo blokea",
  "block.minecraft.quartz_bricks": "kuartzozko adreiluak",
  "block.minecraft.quartz_pillar": "kuartzozko zutabea",
  "block.minecraft.quartz_stairs": "kuartzozko eskailerak",
  "block.minecraft.activator_rail": "aktibatzailedun erraila",
  "block.minecraft.dropper": "jaurtigailua",
  "block.minecraft.white_terracotta": "terrakota zuria",
  "block.minecraft.orange_terracotta": "terrakota laranja",
  "block.minecraft.magenta_terracotta": "terrakota magenta",
  "block.minecraft.light_blue_terracotta": "terrakota urdin argia",
  "block.minecraft.yellow_terracotta": "terrakota horia",
  "block.minecraft.lime_terracotta": "terrakota lima",
  "block.minecraft.pink_terracotta": "terrakota arrosa",
  "block.minecraft.gray_terracotta": "terrakota grisa",
  "block.minecraft.light_gray_terracotta": "terrakota gris argia",
  "block.minecraft.cyan_terracotta": "terrakota ziana",
  "block.minecraft.purple_terracotta": "terrakota morea",
  "block.minecraft.blue_terracotta": "terrakota urdina",
  "block.minecraft.brown_terracotta": "terrakota marroia",
  "block.minecraft.green_terracotta": "terrakota berdea",
  "block.minecraft.red_terracotta": "terrakota gorria",
  "block.minecraft.black_terracotta": "terrakota beltza",
  "block.minecraft.barrier": "barrera",
  "block.minecraft.iron_trapdoor": "burdinazko tranpola",
  "block.minecraft.hay_block": "lasto fardoa",
  "block.minecraft.white_carpet": "alfonbra zuria",
  "block.minecraft.orange_carpet": "laranja koloreko alfonbra",
  "block.minecraft.magenta_carpet": "magenta koloreko alfonbra",
  "block.minecraft.light_blue_carpet": "urdin argi koloreko alfonbra",
  "block.minecraft.yellow_carpet": "hori koloreko alfonbra",
  "block.minecraft.lime_carpet": "lima koloreko alfonbra",
  "block.minecraft.pink_carpet": "arrosa koloreko alfonbra",
  "block.minecraft.gray_carpet": "gris koloreko alfonbra",
  "block.minecraft.light_gray_carpet": "alfonbra gris argia",
  "block.minecraft.cyan_carpet": "zian koloreko alfonbra",
  "block.minecraft.purple_carpet": "more koloreko alfonbra",
  "block.minecraft.blue_carpet": "urdin koloreko alfonbra",
  "block.minecraft.brown_carpet": "marroi koloreko alfonbra",
  "block.minecraft.green_carpet": "berde koloreko alfonbra",
  "block.minecraft.red_carpet": "gorri koloreko alfonbra",
  "block.minecraft.black_carpet": "beltz koloreko alfonbra",
  "block.minecraft.terracotta": "terrakota",
  "block.minecraft.coal_block": "ikatz blokea",
  "block.minecraft.packed_ice": "izotz konprimitua",
  "block.minecraft.acacia_stairs": "akaziazko eskailerak",
  "block.minecraft.dark_oak_stairs": "haritz ilunezko eskailerak",
  "block.minecraft.slime_block": "likati blokea",
  "block.minecraft.grass_path": "belarbidea",
  "block.minecraft.sunflower": "eguzki-lorea",
  "block.minecraft.lilac": "lila",
  "block.minecraft.rose_bush": "arrosondoa",
  "block.minecraft.peony": "oinlodia",
  "block.minecraft.tall_grass": "belar luzea",
  "block.minecraft.large_fern": "iratze handia",
  "block.minecraft.white_stained_glass": "kristal zuria",
  "block.minecraft.orange_stained_glass": "kristal laranja",
  "block.minecraft.magenta_stained_glass": "kristal magenta",
  "block.minecraft.light_blue_stained_glass": "kristal urdin argia",
  "block.minecraft.yellow_stained_glass": "kristal horia",
  "block.minecraft.lime_stained_glass": "kristal lima",
  "block.minecraft.pink_stained_glass": "kristal arrosa",
  "block.minecraft.gray_stained_glass": "kristal grisa",
  "block.minecraft.light_gray_stained_glass": "kristal gris argia",
  "block.minecraft.cyan_stained_glass": "zian koloreko kristala",
  "block.minecraft.purple_stained_glass": "kristal morea",
  "block.minecraft.blue_stained_glass": "kristal urdina",
  "block.minecraft.brown_stained_glass": "kristal marroia",
  "block.minecraft.green_stained_glass": "kristal berdea",
  "block.minecraft.red_stained_glass": "kristal gorria",
  "block.minecraft.black_stained_glass": "kristal beltza",
  "block.minecraft.white_stained_glass_pane": "kristalezko panel zuria",
  "block.minecraft.orange_stained_glass_pane": "kristalezko panel laranja",
  "block.minecraft.magenta_stained_glass_pane": "kristalezko panel magenta",
  "block.minecraft.light_blue_stained_glass_pane": "kristalezko panel urdin argia",
  "block.minecraft.yellow_stained_glass_pane": "kristalezko panel horia",
  "block.minecraft.lime_stained_glass_pane": "lima koloreko kristalezko panela",
  "block.minecraft.pink_stained_glass_pane": "kristalezko panel arrosa",
  "block.minecraft.gray_stained_glass_pane": "kristalezko panel grisa",
  "block.minecraft.light_gray_stained_glass_pane": "kristalezko panel gris argia",
  "block.minecraft.cyan_stained_glass_pane": "zian koloreko kristalezko panela",
  "block.minecraft.purple_stained_glass_pane": "kristalezko panel morea",
  "block.minecraft.blue_stained_glass_pane": "kristalezko panel urdina",
  "block.minecraft.brown_stained_glass_pane": "kristalezko panel marroia",
  "block.minecraft.green_stained_glass_pane": "kristalezko panel berdea",
  "block.minecraft.red_stained_glass_pane": "kristalezko panel gorria",
  "block.minecraft.black_stained_glass_pane": "kristalezko panel beltza",
  "block.minecraft.prismarine": "prismarina",
  "block.minecraft.prismarine_bricks": "prismarina adreiluak",
  "block.minecraft.dark_prismarine": "prismarina iluna",
  "block.minecraft.prismarine_stairs": "prismarina eskailerak",
  "block.minecraft.prismarine_brick_stairs": "prismarina adreiluzko eskailerak",
  "block.minecraft.dark_prismarine_stairs": "prismarine eskailera ilunak",
  "block.minecraft.sea_lantern": "itsas linterna",
  "block.minecraft.red_sandstone": "hareharri gorria",
  "block.minecraft.chiseled_red_sandstone": "hareharri gorri zizelkatua",
  "block.minecraft.cut_red_sandstone": "moztutako harearri gorria",
  "block.minecraft.red_sandstone_stairs": "hareharri gorrizko eskailerak",
  "block.minecraft.repeating_command_block": "iterazio-agindu blokea",
  "block.minecraft.chain_command_block": "kate-agindu blokea",
  "block.minecraft.magma_block": "magma blokea",
  "block.minecraft.nether_wart_block": "netherreko garatxozko blokea",
  "block.minecraft.warped_wart_block": "garatxo-bloke gaiztoa",
  "block.minecraft.red_nether_bricks": "netherreko adreilu gorriak",
  "block.minecraft.bone_block": "hezur blokea",
  "block.minecraft.structure_void": "egitura hutsunea",
  "block.minecraft.observer": "behatzailea",
  "block.minecraft.shulker_box": "shulker kutxa",
  "block.minecraft.white_shulker_box": "shulker kutxa zuria",
  "block.minecraft.orange_shulker_box": "shulker kutxa laranja",
  "block.minecraft.magenta_shulker_box": "shulker kutxa magenta",
  "block.minecraft.light_blue_shulker_box": "shulker kutxa urdin argia",
  "block.minecraft.yellow_shulker_box": "shulker kutxa horia",
  "block.minecraft.lime_shulker_box": "shulker kutxa berde lima",
  "block.minecraft.pink_shulker_box": "shulker kutxa arrosa",
  "block.minecraft.gray_shulker_box": "shulker kutxa grisa",
  "block.minecraft.light_gray_shulker_box": "shulker kutxa gris argia",
  "block.minecraft.cyan_shulker_box": "shulker kutxa ziana",
  "block.minecraft.purple_shulker_box": "shulker kutxa morea",
  "block.minecraft.blue_shulker_box": "shulker kutxa urdina",
  "block.minecraft.brown_shulker_box": "shulker kutxa marroia",
  "block.minecraft.green_shulker_box": "shulker kutxa berdea",
  "block.minecraft.red_shulker_box": "shulker kutxa gorria",
  "block.minecraft.black_shulker_box": "shulker kutxa beltza",
  "block.minecraft.white_glazed_terracotta": "terrakota beiraztatu zuria",
  "block.minecraft.orange_glazed_terracotta": "terrakota beiraztatu laranja",
  "block.minecraft.magenta_glazed_terracotta": "terrakota beiraztatu magenta",
  "block.minecraft.light_blue_glazed_terracotta": "terrakota beiraztatu urdin argia",
  "block.minecraft.yellow_glazed_terracotta": "terrakota beiraztatu horia",
  "block.minecraft.lime_glazed_terracotta": "terrakota beiraztatu lima",
  "block.minecraft.pink_glazed_terracotta": "terrakota beiraztatu arrosa",
  "block.minecraft.gray_glazed_terracotta": "terrakota beiraztatu grisa",
  "block.minecraft.light_gray_glazed_terracotta": "terrakota beiraztatu gris argia",
  "block.minecraft.cyan_glazed_terracotta": "terrakota beiraztatu ziana",
  "block.minecraft.purple_glazed_terracotta": "terrakota beiraztatu morea",
  "block.minecraft.blue_glazed_terracotta": "terrakota beiraztatu urdina",
  "block.minecraft.brown_glazed_terracotta": "terrakota beiraztatu marroia",
  "block.minecraft.green_glazed_terracotta": "terrakota beiraztatu berdea",
  "block.minecraft.red_glazed_terracotta": "terrakota beiraztatu gorria",
  "block.minecraft.black_glazed_terracotta": "terrakota beiraztatu beltza",
  "block.minecraft.white_concrete": "hormigoi zuria",
  "block.minecraft.orange_concrete": "hormigoi laranja",
  "block.minecraft.magenta_concrete": "hormigoi magenta",
  "block.minecraft.light_blue_concrete": "hormigoi urdin argia",
  "block.minecraft.yellow_concrete": "hormigoi horia",
  "block.minecraft.lime_concrete": "hormigoi lima",
  "block.minecraft.pink_concrete": "hormigoi arrosa",
  "block.minecraft.gray_concrete": "hormigoi grisa",
  "block.minecraft.light_gray_concrete": "hormigoi gris argia",
  "block.minecraft.cyan_concrete": "hormigoi ziana",
  "block.minecraft.purple_concrete": "hormigoi morea",
  "block.minecraft.blue_concrete": "hormigoi urdina",
  "block.minecraft.brown_concrete": "hormigoi marroia",
  "block.minecraft.green_concrete": "hormigoi berdea",
  "block.minecraft.red_concrete": "hormigoi gorria",
  "block.minecraft.black_concrete": "hormigoi beltza",
  "block.minecraft.white_concrete_powder": "zementu zuria",
  "block.minecraft.orange_concrete_powder": "zementu laranja",
  "block.minecraft.magenta_concrete_powder": "zementu magenta",
  "block.minecraft.light_blue_concrete_powder": "zementu urdin argia",
  "block.minecraft.yellow_concrete_powder": "zementu horia",
  "block.minecraft.lime_concrete_powder": "zementu lima",
  "block.minecraft.pink_concrete_powder": "zementu arrosa",
  "block.minecraft.gray_concrete_powder": "zementu grisa",
  "block.minecraft.light_gray_concrete_powder": "zementu gris argia",
  "block.minecraft.cyan_concrete_powder": "zementu ziana",
  "block.minecraft.purple_concrete_powder": "zementu morea",
  "block.minecraft.blue_concrete_powder": "zementu urdina",
  "block.minecraft.brown_concrete_powder": "zementu marroia",
  "block.minecraft.green_concrete_powder": "zementu berdea",
  "block.minecraft.red_concrete_powder": "zementu gorria",
  "block.minecraft.black_concrete_powder": "zementu beltza",
  "block.minecraft.turtle_egg": "dortoka-arrautza",
  "block.minecraft.dead_tube_coral_block": "bizigabeko hodizko koral blokea",
  "block.minecraft.dead_brain_coral_block": "bizigabeko burmuinezko koral blokea",
  "block.minecraft.dead_bubble_coral_block": "hildako burbuila coral blokea",
  "block.minecraft.dead_fire_coral_block": "hildako su koral blokea",
  "block.minecraft.dead_horn_coral_block": "hildako egurra coral blokea",
  "block.minecraft.tube_coral_block": "bizigabeko hodi koral blokea",
  "block.minecraft.brain_coral_block": "bizigabeko burmuin koral blokea",
  "block.minecraft.bubble_coral_block": "bizigabeko burbuila koral blokea",
  "block.minecraft.fire_coral_block": "bizigabeko su koral blokea",
  "block.minecraft.horn_coral_block": "bizigabeko adar koral blokea",
  "block.minecraft.tube_coral": "hodizko korala",
  "block.minecraft.brain_coral": "burmuin korala",
  "block.minecraft.bubble_coral": "hodizko korala",
  "block.minecraft.fire_coral": "hodizko korala",
  "block.minecraft.horn_coral": "hodizko korala",
  "block.minecraft.dead_brain_coral": "bizigabeko burmuinezko koral blokea",
  "block.minecraft.dead_bubble_coral": "hodizko korala",
  "block.minecraft.dead_fire_coral": "bizigabeko hodizko koral blokea",
  "block.minecraft.dead_horn_coral": "bizigabeko hodizko koral blokea",
  "block.minecraft.dead_tube_coral": "bizigabeko hodizko koral blokea",
  "block.minecraft.tube_coral_fan": "hodizko korala",
  "block.minecraft.brain_coral_fan": "burmuin korala",
  "block.minecraft.bubble_coral_fan": "hodizko korala",
  "block.minecraft.fire_coral_fan": "hodizko korala",
  "block.minecraft.horn_coral_fan": "hodizko korala",
  "block.minecraft.dead_tube_coral_fan": "hildako hodi coral fan",
  "block.minecraft.dead_brain_coral_fan": "hildako garuneko coral fan",
  "block.minecraft.dead_bubble_coral_fan": "hildako burbuila coral fan",
  "block.minecraft.dead_fire_coral_fan": "hildako sute coral fan",
  "block.minecraft.dead_horn_coral_fan": "hildako hodizko koral fan",
  "block.minecraft.blue_ice": "izotz urdina",
  "block.minecraft.conduit": "kanalizatzailea",
  "block.minecraft.polished_granite_stairs": "txartatutako granitozko eskailerak",
  "block.minecraft.smooth_red_sandstone_stairs": "hareharri gorri leunezko eskailerak",
  "block.minecraft.mossy_stone_brick_stairs": "harri goroldiotsu adreiluzko eskailerak",
  "block.minecraft.polished_diorite_stairs": "txartatutako dioritazko eskailerak",
  "block.minecraft.mossy_cobblestone_stairs": "arroka goroldiotsuzko eskailerak",
  "block.minecraft.end_stone_brick_stairs": "amaierako arroka adreiluzko eskailerak",
  "block.minecraft.stone_stairs": "harrizko eskailerak",
  "block.minecraft.smooth_sandstone_stairs": "hareharri leunezko eskailerak",
  "block.minecraft.smooth_quartz_stairs": "kuartzo leunezko eskailerak",
  "block.minecraft.granite_stairs": "ganito eskailerak",
  "block.minecraft.andesite_stairs": "andesita eskailerak",
  "block.minecraft.red_nether_brick_stairs": "netherreko adreilu gorrizko eskailerak",
  "block.minecraft.polished_andesite_stairs": "txartatutako andesitazko eskailerak",
  "block.minecraft.diorite_stairs": "dioritazko eskailerak",
  "block.minecraft.polished_granite_slab": "txartatutako granitozko lauza",
  "block.minecraft.smooth_red_sandstone_slab": "hareharri gorri leunezko lauza",
  "block.minecraft.mossy_stone_brick_slab": "harri goroldiotsuzko adreiluzko lauza",
  "block.minecraft.polished_diorite_slab": "txartatutako dioritazko lauza",
  "block.minecraft.mossy_cobblestone_slab": "arroka goroldiotsuzko lauza",
  "block.minecraft.end_stone_brick_slab": "endeko harrizko adreiluzko lauza",
  "block.minecraft.smooth_sandstone_slab": "hareharri leunezko lauza",
  "block.minecraft.smooth_quartz_slab": "kuartzo leunezko lauza",
  "block.minecraft.granite_slab": "ganito lauza",
  "block.minecraft.andesite_slab": "andesitazko lauza",
  "block.minecraft.red_nether_brick_slab": "netherreko adreilu gorrizko lauza",
  "block.minecraft.polished_andesite_slab": "txartatutako andesitazko lauza",
  "block.minecraft.diorite_slab": "dioritazko lauza",
  "block.minecraft.scaffolding": "aldamioa",
  "block.minecraft.iron_door": "burdinazko atea",
  "block.minecraft.oak_door": "haritzezko atea",
  "block.minecraft.spruce_door": "izeizko atea",
  "block.minecraft.birch_door": "urkizko atea",
  "block.minecraft.jungle_door": "oihanezko atea",
  "block.minecraft.acacia_door": "akaziazko atea",
  "block.minecraft.dark_oak_door": "haritz ilunezko atea",
  "block.minecraft.crimson_door": "ate gorrimina",
  "block.minecraft.warped_door": "ate okertua",
  "block.minecraft.repeater": "redstone-errepikagailua",
  "block.minecraft.comparator": "redstone-konparadorea",
  "block.minecraft.structure_block": "egitura blokea",
  "block.minecraft.jigsaw": "buruhausgarri blokea",
  "item.minecraft.turtle_helmet": "dortoka-oskola□□buruan:□+2 armadura",
  "item.minecraft.scute": "dortoka ezkata",
  "item.minecraft.iron_shovel": "burdinazko pala□□esku nagusian:□+3.5 eraso kaltea□-3 eraso abiadura",
  "item.minecraft.iron_pickaxe": "burdinazko pikotxa□□esku nagusian:□+3 eraso kaltea□-2.8 eraso abiadura",
  "item.minecraft.iron_axe": "burdinazko aizkora□□esku nagusian:□+8 eraso kaltea□-3.1 eraso abiadura",
  "item.minecraft.flint_and_steel": "suharria eta burdina",
  "item.minecraft.apple": "sagarra",
  "item.minecraft.bow": "arkua",
  "item.minecraft.arrow": "gezia",
  "item.minecraft.coal": "ikatza",
  "item.minecraft.charcoal": "egur-ikatza",
  "item.minecraft.diamond": "diamantea",
  "item.minecraft.iron_ingot": "burdinazko lingotea",
  "item.minecraft.gold_ingot": "urrezko lingotea",
  "item.minecraft.netherite_ingot": "netheritazko lingotea",
  "item.minecraft.netherite_scrap": "netheritazko puskak",
  "item.minecraft.iron_sword": "burdinazko ezpata□□esku nagusian:□+5 eraso kaltea□-2.4 eraso abiadura",
  "item.minecraft.wooden_sword": "zurezko ezpata□□esku nagusian:□+3 eraso kaltea□-2.4 eraso abiadura",
  "item.minecraft.wooden_shovel": "zurezko pala□□esku nagusian:□+1.5 eraso kaltea□-3 eraso abiadura",
  "item.minecraft.wooden_pickaxe": "zurezko pikotxa□□esku nagusian:□+1 eraso kaltea□-2.8 eraso abiadura",
  "item.minecraft.wooden_axe": "zurezko aizkora□□esku nagusian:□+6 eraso kaltea□-3.2 eraso abiadura",
  "item.minecraft.stone_sword": "harrizko ezpata□□esku nagusian:□+4 eraso kaltea□-2.4 eraso abiadura",
  "item.minecraft.stone_shovel": "harrizko pala□□esku nagusian:□+2.5 eraso kaltea□-3 eraso abiadura",
  "item.minecraft.stone_pickaxe": "harrizko pikotxa□□esku nagusian:□+2 eraso kaltea□-2.8 eraso abiadura",
  "item.minecraft.stone_axe": "harrizko aizkora□□esku nagusian:□+8 eraso kaltea□-3.2 eraso abiadura",
  "item.minecraft.diamond_sword": "diamantezko ezpata□□esku nagusian:□+6 eraso kaltea□-2.4 eraso abiadura",
  "item.minecraft.diamond_shovel": "diamantezko pala□□esku nagusian:□+4.5 eraso kaltea□-3 eraso abiadura",
  "item.minecraft.diamond_pickaxe": "diamantezko pikotxa□□esku nagusian:□+4 eraso kaltea□-2.8 eraso abiadura",
  "item.minecraft.diamond_axe": "diamantezko aizkora□□esku nagusian:□+8 eraso kaltea□-3 eraso abiadura",
  "item.minecraft.stick": "makila",
  "item.minecraft.bowl": "katilua",
  "item.minecraft.mushroom_stew": "perretxiko erregosia",
  "item.minecraft.golden_sword": "urrezko ezpata□□esku nagusian:□+3 eraso kaltea□-2.4 eraso abiadura",
  "item.minecraft.golden_shovel": "urrezko pala□□esku nagusian:□+1.5 eraso kaltea□-3 eraso abiadura",
  "item.minecraft.golden_pickaxe": "urrezko pikotxa□□esku nagusian:□+1 eraso kaltea□-2.8 eraso abiadura",
  "item.minecraft.golden_axe": "urrezko aizkora□□esku nagusian:□+6 eraso kaltea□-3 eraso abiadura",
  "item.minecraft.netherite_sword": "netheritazko ezpata□□esku nagusian:□+7 eraso kaltea□-2.4 eraso abiadura",
  "item.minecraft.netherite_shovel": "netheritazko pala□□esku nagusian:□+5.5 eraso kaltea□-3 eraso abiadura",
  "item.minecraft.netherite_pickaxe": "netheritazko pikotxa□□esku nagusian:□+5 eraso kaltea□-2.8 eraso abiadura",
  "item.minecraft.netherite_axe": "netheritazko aizkora□□esku nagusian:□+9 eraso kaltea□-3 eraso abiadura",
  "item.minecraft.string": "haria",
  "item.minecraft.feather": "luma",
  "item.minecraft.gunpowder": "bolbora",
  "item.minecraft.wooden_hoe": "zurezko aitzurra□□esku nagusian:□-3 eraso abiadura",
  "item.minecraft.stone_hoe": "harrizko aitzurra□□esku nagusian:□-2 eraso abiadura",
  "item.minecraft.iron_hoe": "burdinazko aitzurra□□esku nagusian:□-1 eraso abiadura",
  "item.minecraft.diamond_hoe": "diamantezko aitzurra□□esku nagusian:",
  "item.minecraft.golden_hoe": "urrezko aitzurra□□esku nagusian:□-3 eraso abiadura",
  "item.minecraft.netherite_hoe": "netheritazko aitzurra□□esku nagusian:",
  "item.minecraft.wheat_seeds": "gari haziak",
  "item.minecraft.wheat": "garia",
  "item.minecraft.bread": "ogia",
  "item.minecraft.leather_helmet": "larruzko txapela□□buruan:□+1 armadura",
  "item.minecraft.leather_chestplate": "larruzko tunika□□gorputzean:□+3 armadura",
  "item.minecraft.leather_leggings": "larruzko galtzak□□hanketan:□+2 armadura",
  "item.minecraft.leather_boots": "larruzko botak□□oinetan:□+1 armadura",
  "item.minecraft.chainmail_helmet": "kotazko kaskoa□□buruan:□+2 armadura",
  "item.minecraft.chainmail_chestplate": "kotazko bular-oskola□□gorputzean:□+5 armadura",
  "item.minecraft.chainmail_leggings": "kotazko zangoak□□hanketan:□+4 armadura",
  "item.minecraft.chainmail_boots": "kotazko botak□□oinetan:□+1 armadura",
  "item.minecraft.iron_helmet": "burdinazko kaskoa□□buruan:□+2 armadura",
  "item.minecraft.iron_chestplate": "burdinazko bular-oskola□□gorputzean:□+6 armadura",
  "item.minecraft.iron_leggings": "burdinazko zangoak□□hanketan:□+5 armadura",
  "item.minecraft.iron_boots": "burdinazko botak□□oinetan:□+2 armadura",
  "item.minecraft.diamond_helmet": "diamantezko kaskoa□□buruan:□+3 armadura□+2 armaduraren erresistentzia",
  "item.minecraft.diamond_chestplate": "diamantezko bular-oskola□□gorputzean:□+8 armadura□+2 armaduraren erresistentzia",
  "item.minecraft.diamond_leggings": "diamantezko zangoak□□hanketan:□+6 armadura□+2 armaduraren erresistentzia",
  "item.minecraft.diamond_boots": "diamantezko botak□□oinetan:□+3 armadura□+2 armaduraren erresistentzia",
  "item.minecraft.golden_helmet": "urrezko kaskoa□□buruan:□+2 armadura",
  "item.minecraft.golden_chestplate": "urrezko bular-oskola□□gorputzean:□+5 armadura",
  "item.minecraft.golden_leggings": "urrezko zangoak□□hanketan:□+3 armadura",
  "item.minecraft.golden_boots": "urrezko botak□□oinetan:□+1 armadura",
  "item.minecraft.netherite_helmet": "netheritazko kaskoa□□buruan:□+3 armadura□+3 armaduraren erresistentzia□+1 errebesaren aurkako erresistentzia",
  "item.minecraft.netherite_chestplate": "netheritazko bular-oskola□□gorputzean:□+8 armadura□+3 armaduraren erresistentzia□+1 errebesaren aurkako erresistentzia",
  "item.minecraft.netherite_leggings": "netheritazko zangoak□□hanketan:□+6 armadura□+3 armaduraren erresistentzia□+1 errebesaren aurkako erresistentzia",
  "item.minecraft.netherite_boots": "netheritazko botak□□oinetan:□+3 armadura□+3 armaduraren erresistentzia□+1 errebesaren aurkako erresistentzia",
  "item.minecraft.flint": "suharria",
  "item.minecraft.porkchop": "txerri txuleta gordina",
  "item.minecraft.cooked_porkchop": "txerri txuleta errea",
  "item.minecraft.painting": "margolana",
  "item.minecraft.golden_apple": "urrezko sagarra",
  "item.minecraft.enchanted_golden_apple": "sorgindutako urrezko sagarra",
  "block.minecraft.oak_sign": "haritzezko kartela",
  "block.minecraft.spruce_sign": "izeizko kartela",
  "block.minecraft.birch_sign": "urkizko kartela",
  "block.minecraft.jungle_sign": "oihanezko kartela",
  "block.minecraft.acacia_sign": "akaziazko kartela",
  "block.minecraft.dark_oak_sign": "haritz ilunezko kartela",
  "block.minecraft.crimson_sign": "kartel gorrimina",
  "block.minecraft.warped_sign": "kartel okertua",
  "item.minecraft.bucket": "ontzia",
  "item.minecraft.water_bucket": "ur ontzia",
  "item.minecraft.lava_bucket": "laba ontzia",
  "item.minecraft.minecart": "bagoneta",
  "item.minecraft.saddle": "zaltokia",
  "item.minecraft.redstone": "redstone-hautsa",
  "item.minecraft.snowball": "elur bola",
  "item.minecraft.oak_boat": "haritzezko txalupa",
  "item.minecraft.leather": "larrua",
  "item.minecraft.milk_bucket": "esnea ontzia",
  "item.minecraft.pufferfish_bucket": "globo-arrain kuboa",
  "item.minecraft.salmon_bucket": "izokin ontziratua",
  "item.minecraft.cod_bucket": "bakailao ontziratua",
  "item.minecraft.tropical_fish_bucket": "arrain tropikal ontziratua",
  "item.minecraft.brick": "adreilua",
  "item.minecraft.clay_ball": "buztinezko bola",
  "block.minecraft.dried_kelp_block": "lehortutako alga blokea",
  "item.minecraft.paper": "papera",
  "item.minecraft.book": "liburua",
  "item.minecraft.slime_ball": "likati-bola",
  "item.minecraft.chest_minecart": "bagoneta kutxarekin",
  "item.minecraft.furnace_minecart": "bagoneta labearekin",
  "item.minecraft.egg": "arrautza",
  "item.minecraft.compass": "iparrorratza",
  "item.minecraft.fishing_rod": "arrantzarako kanabera",
  "item.minecraft.clock": "erlojua",
  "item.minecraft.glowstone_dust": "argi-harriaren hautsa",
  "item.minecraft.cod": "bakailao gordina",
  "item.minecraft.salmon": "izokin gordina",
  "item.minecraft.tropical_fish": "arrain tropikala",
  "item.minecraft.pufferfish": "globo arraina",
  "item.minecraft.cooked_cod": "bakailao errea",
  "item.minecraft.cooked_salmon": "izokin errea",
  "item.minecraft.ink_sac": "tinta zakua",
  "item.minecraft.red_dye": "tindagai gorria",
  "item.minecraft.green_dye": "tindagai berdea",
  "item.minecraft.cocoa_beans": "kakao aleak",
  "item.minecraft.lapis_lazuli": "lapis lazulia",
  "item.minecraft.purple_dye": "tindagai morea",
  "item.minecraft.cyan_dye": "zian koloreko tindagaia",
  "item.minecraft.light_gray_dye": "tindagai gris argia",
  "item.minecraft.gray_dye": "tindagai grisa",
  "item.minecraft.pink_dye": "tindagai arrosa",
  "item.minecraft.lime_dye": "lima koloreko tindagaia",
  "item.minecraft.yellow_dye": "tindagai horia",
  "item.minecraft.light_blue_dye": "tindagai urdin argia",
  "item.minecraft.magenta_dye": "tindagai magenta",
  "item.minecraft.orange_dye": "tindagai laranja",
  "item.minecraft.bone_meal": "hezur hautsa",
  "item.minecraft.blue_dye": "tindagai urdina",
  "item.minecraft.brown_dye": "tindagai marroia",
  "item.minecraft.black_dye": "tindagai beltza",
  "item.minecraft.white_dye": "tindagai zuria",
  "item.minecraft.bone": "hezurra",
  "item.minecraft.sugar": "azukrea",
  "block.minecraft.cake": "tarta",
  "block.minecraft.white_bed": "ohe zuria",
  "block.minecraft.orange_bed": "ohe laranja",
  "block.minecraft.magenta_bed": "ohe magenta",
  "block.minecraft.light_blue_bed": "ohe urdin argia",
  "block.minecraft.yellow_bed": "ohe horia",
  "block.minecraft.lime_bed": "ohe lima",
  "block.minecraft.pink_bed": "ohe arrosa",
  "block.minecraft.gray_bed": "ohe grisa",
  "block.minecraft.light_gray_bed": "ohe gris argia",
  "block.minecraft.cyan_bed": "ohe ziana",
  "block.minecraft.purple_bed": "ohe morea",
  "block.minecraft.blue_bed": "ohe urdina",
  "block.minecraft.brown_bed": "ohe marroia",
  "block.minecraft.green_bed": "ohe berdea",
  "block.minecraft.red_bed": "ohe gorria",
  "block.minecraft.black_bed": "ohe beltza",
  "item.minecraft.cookie": "galleta",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "guraizeak",
  "item.minecraft.melon_slice": "meloi zatia",
  "item.minecraft.dried_kelp": "lehortutako algak",
  "item.minecraft.pumpkin_seeds": "kalabaza-haziak",
  "item.minecraft.melon_seeds": "meloiaren haziak",
  "item.minecraft.beef": "txekor gordina",
  "item.minecraft.cooked_beef": "xerra",
  "item.minecraft.chicken": "oilasko gordina",
  "item.minecraft.cooked_chicken": "oilasko errea",
  "item.minecraft.rotten_flesh": "haragi usteldua",
  "item.minecraft.ender_pearl": "ender perla",
  "item.minecraft.blaze_rod": "sutzarraren hagaxka",
  "item.minecraft.ghast_tear": "ghast malkoa",
  "item.minecraft.gold_nugget": "urrezko pipitak",
  "item.minecraft.nether_wart": "netherreko garatxoa",
  "item.minecraft.potion": "edabea egin ezina□efekturik ez",
  "item.minecraft.glass_bottle": "kristalezko botila",
  "item.minecraft.spider_eye": "armiarmaren begia",
  "item.minecraft.fermented_spider_eye": "legamiatutako armiarma begiak",
  "item.minecraft.blaze_powder": "sutzarraren hautsa",
  "item.minecraft.magma_cream": "magma krema",
  "block.minecraft.brewing_stand": "edabegintzarako euskarria",
  "block.minecraft.cauldron": "lapikoa",
  "item.minecraft.ender_eye": "ender begia",
  "item.minecraft.glistering_melon_slice": "meloi distiratsu zatia",
  "item.minecraft.bat_spawn_egg": "saguzar sortzaile arrautza",
  "item.minecraft.bee_spawn_egg": "erle sortzaile arrautza",
  "item.minecraft.blaze_spawn_egg": "sutzar sortzaile arrautza",
  "item.minecraft.cat_spawn_egg": "katu sortzaile arrautza",
  "item.minecraft.cave_spider_spawn_egg": "kobazuloetako armiarma sortzaile arrautza",
  "item.minecraft.chicken_spawn_egg": "oilo sortzaile arrautza",
  "item.minecraft.cod_spawn_egg": "bakailao sortzaile arrautza",
  "item.minecraft.cow_spawn_egg": "behi sortzaile arrautza",
  "item.minecraft.creeper_spawn_egg": "creeper sortzaile arrautza",
  "item.minecraft.dolphin_spawn_egg": "izurde sortzaile arrautza",
  "item.minecraft.donkey_spawn_egg": "asto sortzaile arrautza",
  "item.minecraft.drowned_spawn_egg": "ito sortzaile arrautza",
  "item.minecraft.elder_guardian_spawn_egg": "zaindari nagusi sortzaile arrautza",
  "item.minecraft.enderman_spawn_egg": "enderman sortzaile arrautza",
  "item.minecraft.endermite_spawn_egg": "endermite sortzaile arrautza",
  "item.minecraft.evoker_spawn_egg": "inbokatzaile sortzaile arrautza",
  "item.minecraft.fox_spawn_egg": "azeri sortzaile arrautza",
  "item.minecraft.ghast_spawn_egg": "ghast sortzaile arrautza",
  "item.minecraft.guardian_spawn_egg": "zaindari sortzaile arrautza",
  "item.minecraft.hoglin_spawn_egg": "hoglin sortzaile arrautza",
  "item.minecraft.horse_spawn_egg": "zaldi sortzaile arrautza",
  "item.minecraft.husk_spawn_egg": "zonbie momifikatu sortzaile arrautza",
  "item.minecraft.llama_spawn_egg": "llama sortzaile arrautza",
  "item.minecraft.magma_cube_spawn_egg": "magma kubo sortzaile arrautza",
  "item.minecraft.mooshroom_spawn_egg": "perretxiko-behi sortzaile arrautza",
  "item.minecraft.mule_spawn_egg": "mando sortzaile arrautza",
  "item.minecraft.ocelot_spawn_egg": "ozelote sortzaile arrautza",
  "item.minecraft.panda_spawn_egg": "panda sortzaile arrautza",
  "item.minecraft.parrot_spawn_egg": "loro sortzaile arrautza",
  "item.minecraft.phantom_spawn_egg": "mamu sortzaile arrautza",
  "item.minecraft.pig_spawn_egg": "txerri sortzaile arrautza",
  "item.minecraft.piglin_spawn_egg": "piglin sortzaile arrautza",
  "item.minecraft.pillager_spawn_egg": "arpilatzaile sortzaile arrautza",
  "item.minecraft.polar_bear_spawn_egg": "hartz polar sortzaile arrautza",
  "item.minecraft.pufferfish_spawn_egg": "globo-arrain sortzaile arrautza",
  "item.minecraft.rabbit_spawn_egg": "untxi sortzaile arrautza",
  "item.minecraft.ravager_spawn_egg": "suntsitzaile sortzaile arrautza",
  "item.minecraft.salmon_spawn_egg": "izokin sortzaile arrautza",
  "item.minecraft.sheep_spawn_egg": "ardi sortzaile arrautza",
  "item.minecraft.shulker_spawn_egg": "shulker sortzaile arrautza",
  "item.minecraft.silverfish_spawn_egg": "zilar-arrain sortzaile arrautza",
  "item.minecraft.skeleton_spawn_egg": "eskeleto sortzaile arrautza",
  "item.minecraft.skeleton_horse_spawn_egg": "eskeleto-zaldi sortzaile arrautza",
  "item.minecraft.slime_spawn_egg": "slime sortzaile arrautza",
  "item.minecraft.spider_spawn_egg": "armiarma sortzaile arrautza",
  "item.minecraft.squid_spawn_egg": "txibia sortzaile arrautza",
  "item.minecraft.stray_spawn_egg": "eskeleto glazial sortzaile arrautza",
  "item.minecraft.strider_spawn_egg": "zangokari sortzaile arrautza",
  "item.minecraft.trader_llama_spawn_egg": "llama ibiltari agerpen arrautza",
  "item.minecraft.tropical_fish_spawn_egg": "arrain tropikal sortzaile arrautza",
  "item.minecraft.turtle_spawn_egg": "dortoka sortzaile arrautza",
  "item.minecraft.vex_spawn_egg": "arima sortzaile arrautza",
  "item.minecraft.villager_spawn_egg": "herritar sortzaile arrautza",
  "item.minecraft.vindicator_spawn_egg": "erasotzaile sortzaile arrautza",
  "item.minecraft.wandering_trader_spawn_egg": "saltzaile ibiltari agerpen arrautza",
  "item.minecraft.witch_spawn_egg": "sorgin sortzaile arrautza",
  "item.minecraft.wither_skeleton_spawn_egg": "wither eskeleto sortzaile arrautza",
  "item.minecraft.wolf_spawn_egg": "otso sortzaile arrautza",
  "item.minecraft.zoglin_spawn_egg": "zoglin sortzaile arrautza",
  "item.minecraft.zombie_spawn_egg": "zonbi sortzaile arrautza",
  "item.minecraft.zombie_horse_spawn_egg": "zonbi-zaldi sortzaile arrautza",
  "item.minecraft.zombie_villager_spawn_egg": "herritar zonbifikatu sortzaile arrautza",
  "item.minecraft.zombified_piglin_spawn_egg": "piglin zonbifikatu sortzaile arrautza",
  "item.minecraft.experience_bottle": "sorginkeri botila",
  "item.minecraft.fire_charge": "su-bola",
  "item.minecraft.writable_book": "liburua eta idazluma",
  "item.minecraft.written_book": "idatzitako liburua",
  "item.minecraft.emerald": "esmeralda",
  "item.minecraft.item_frame": "markodun elementua",
  "block.minecraft.flower_pot": "loreontzi",
  "item.minecraft.carrot": "azenarioa",
  "item.minecraft.potato": "patata",
  "item.minecraft.baked_potato": "patata errea",
  "item.minecraft.poisonous_potato": "patata pozoitsua",
  "item.minecraft.map": "mapa hutsa",
  "item.minecraft.golden_carrot": "urrezko azenarioa",
  "block.minecraft.skeleton_skull": "eskeleto-garezurra",
  "block.minecraft.wither_skeleton_skull": "wither eskeleto-garezurra",
  "block.minecraft.player_head": "jokalari burua",
  "block.minecraft.zombie_head": "zonbi-burua",
  "block.minecraft.creeper_head": "creeper burua",
  "block.minecraft.dragon_head": "dragoi burua",
  "item.minecraft.carrot_on_a_stick": "azenarioa makila batekin",
  "item.minecraft.warped_fungus_on_a_stick": "onddo okertua makila batean",
  "item.minecraft.nether_star": "netherreko izarra",
  "item.minecraft.pumpkin_pie": "kalabaza pastela",
  "item.minecraft.firework_rocket": "suziria",
  "item.minecraft.firework_star": "suziri izarra",
  "item.minecraft.enchanted_book": "sorgindutako liburua",
  "item.minecraft.nether_brick": "netherreko adreilua",
  "item.minecraft.quartz": "netherreko kuartzoa",
  "item.minecraft.tnt_minecart": "bagoneta dinamitarekin",
  "item.minecraft.hopper_minecart": "bagoneta kalapatxarekin",
  "item.minecraft.prismarine_shard": "prismarina puska",
  "item.minecraft.prismarine_crystals": "prismarina kristalak",
  "item.minecraft.rabbit": "untxi gordina",
  "item.minecraft.cooked_rabbit": "untxi errea",
  "item.minecraft.rabbit_stew": "untxi erregosia",
  "item.minecraft.rabbit_foot": "untxi hanka",
  "item.minecraft.rabbit_hide": "untxi-larru",
  "item.minecraft.armor_stand": "armadurarentzako euskarria",
  "item.minecraft.iron_horse_armor": "burdinazko zaldi-armadura",
  "item.minecraft.golden_horse_armor": "urrezko zaldi-armadura",
  "item.minecraft.diamond_horse_armor": "diamantezko zaldi-armadura",
  "item.minecraft.leather_horse_armor": "larruzko zaldi-armadura",
  "item.minecraft.lead": "soka",
  "item.minecraft.name_tag": "izen etiketa",
  "item.minecraft.command_block_minecart": "bagoneta agindu blokearekin",
  "item.minecraft.mutton": "bildots gordina",
  "item.minecraft.cooked_mutton": "bildots errea",
  "block.minecraft.white_banner": "zutoihal zuria",
  "block.minecraft.orange_banner": "zutoihal laranja",
  "block.minecraft.magenta_banner": "zutoihal magenta",
  "block.minecraft.light_blue_banner": "zutoihal urdin argia",
  "block.minecraft.yellow_banner": "zutoihal horia",
  "block.minecraft.lime_banner": "zutohial lima",
  "block.minecraft.pink_banner": "zutoihal arrosa",
  "block.minecraft.gray_banner": "zutoihal grisa",
  "block.minecraft.light_gray_banner": "zutoihal gris argia",
  "block.minecraft.cyan_banner": "zutoihal ziana",
  "block.minecraft.purple_banner": "zutoihal morea",
  "block.minecraft.blue_banner": "zutoihal urdina",
  "block.minecraft.brown_banner": "zutoihal marroia",
  "block.minecraft.green_banner": "zutoihal berdea",
  "block.minecraft.red_banner": "zutoihal gorria",
  "block.minecraft.black_banner": "zutoihal beltza",
  "item.minecraft.end_crystal": "amaierako kristala",
  "item.minecraft.chorus_fruit": "koral fruta",
  "item.minecraft.popped_chorus_fruit": "koral fruta errea",
  "item.minecraft.beetroot": "erremolatxa",
  "item.minecraft.beetroot_seeds": "erremolatxa-hazia",
  "item.minecraft.beetroot_soup": "erremolatxa zopa",
  "item.minecraft.dragon_breath": "dragoiaren hatsa",
  "item.minecraft.splash_potion": "landu ezin daitekeen edabe jaurtigarria□efekturik ez",
  "item.minecraft.spectral_arrow": "gezi espektrala",
  "item.minecraft.tipped_arrow": "efektudun gezi eraikiezina□efekturik ez",
  "item.minecraft.lingering_potion": "edabe ezezagun iraunkorra□efekturik ez",
  "item.minecraft.shield": "ezkutua",
  "item.minecraft.elytra": "elitroak",
  "item.minecraft.spruce_boat": "izeizko txalupa",
  "item.minecraft.birch_boat": "urkizko txalupa",
  "item.minecraft.jungle_boat": "oihan zurezko txalupa",
  "item.minecraft.acacia_boat": "akaziazko txalupa",
  "item.minecraft.dark_oak_boat": "haritz ilunezko txalupa",
  "item.minecraft.totem_of_undying": "hilezkortasunaren totema",
  "item.minecraft.shulker_shell": "shulker oskola",
  "item.minecraft.iron_nugget": "burdinezko pipitak",
  "item.minecraft.knowledge_book": "entziklopedia",
  "item.minecraft.debug_stick": "garatzaile makila",
  "item.minecraft.music_disc_13": "musika diskoa□c418 - 13",
  "item.minecraft.music_disc_cat": "musika diskoa□c418 - cat",
  "item.minecraft.music_disc_blocks": "musika diskoa□c418 - blocks",
  "item.minecraft.music_disc_chirp": "musika diskoa□c418 - chirp",
  "item.minecraft.music_disc_far": "musika diskoa□c418 - far",
  "item.minecraft.music_disc_mall": "musika diskoa□c418 - mall",
  "item.minecraft.music_disc_mellohi": "musika diskoa□c418 - mellohi",
  "item.minecraft.music_disc_stal": "musika diskoa□c418 - stal",
  "item.minecraft.music_disc_strad": "musika diskoa□c418 - strad",
  "item.minecraft.music_disc_ward": "musika diskoa□c418 - ward",
  "item.minecraft.music_disc_11": "musika diskoa□c418 - 11",
  "item.minecraft.music_disc_wait": "musika diskoa□c418 - wait",
  "item.minecraft.music_disc_pigstep": "musika diskoa□lena raine - pigstep",
  "item.minecraft.trident": "hiruhortza□□esku nagusian:□+8 eraso kaltea□-2.9 eraso abiadura",
  "item.minecraft.phantom_membrane": "mamu-mintza",
  "item.minecraft.nautilus_shell": "barraskilo oskola",
  "item.minecraft.heart_of_the_sea": "itsasoaren bihotza",
  "item.minecraft.crossbow": "balezta",
  "item.minecraft.suspicious_stew": "erregosi susmagarria",
  "block.minecraft.loom": "ehungailua",
  "item.minecraft.flower_banner_pattern": "zutoihal-diseinua□lore-estanpatua",
  "item.minecraft.creeper_banner_pattern": "zutoihal-diseinua□creeper-estanpatua",
  "item.minecraft.skull_banner_pattern": "zutoihal-diseinua□garezur-estanpatua",
  "item.minecraft.mojang_banner_pattern": "zutoihal-diseinua□mojang-estanpatua",
  "item.minecraft.globe_banner_pattern": "zutoihal-diseinua□planeta-estanpatua",
  "item.minecraft.piglin_banner_pattern": "zutoihal-diseinua□mutur-estanpatua",
  "block.minecraft.composter": "conpost-ontzia",
  "block.minecraft.barrel": "barrika",
  "block.minecraft.smoker": "keetzailea",
  "block.minecraft.blast_furnace": "labe garaia",
  "block.minecraft.cartography_table": "kartografia taula",
  "block.minecraft.fletching_table": "geziak egiteko taula",
  "block.minecraft.grindstone": "zorrotzailea",
  "block.minecraft.lectern": "argiontzia",
  "block.minecraft.smithing_table": "aroztegi taula",
  "block.minecraft.stonecutter": "harriamozgailua",
  "block.minecraft.bell": "kanpaia",
  "block.minecraft.lantern": "faroltxoa",
  "block.minecraft.soul_lantern": "arima linterna",
  "item.minecraft.sweet_berries": "fruitu gozoak",
  "block.minecraft.campfire": "sutegia",
  "block.minecraft.soul_campfire": "arima kanpamentua",
  "block.minecraft.shroomlight": "argionddoa",
  "item.minecraft.honeycomb": "eztiorrazi",
  "block.minecraft.bee_nest": "erle habia",
  "block.minecraft.beehive": "erlauntza",
  "item.minecraft.honey_bottle": "botila bat ezti",
  "block.minecraft.honey_block": "ezti blokea",
  "block.minecraft.honeycomb_block": "abaraska",
  "block.minecraft.lodestone": "magnetita",
  "block.minecraft.netherite_block": "netheritazko blokea",
  "block.minecraft.ancient_debris": "antzinako hondakinak",
  "block.minecraft.target": "helburua",
  "block.minecraft.crying_obsidian": "obsidiana negarrez",
  "block.minecraft.blackstone": "harribeltza",
  "block.minecraft.blackstone_slab": "harribeltzezko lauza",
  "block.minecraft.blackstone_stairs": "harribeltzezko eskailerak",
  "block.minecraft.gilded_blackstone": "urreztatutako harribeltza",
  "block.minecraft.polished_blackstone": "txartatutako harribeltza",
  "block.minecraft.polished_blackstone_slab": "txartatutako harribeltzezko lauza",
  "block.minecraft.polished_blackstone_stairs": "txartatutako harribeltzezko eskailerak",
  "block.minecraft.chiseled_polished_blackstone": "txartatutako harribeltz zizelkatua",
  "block.minecraft.polished_blackstone_bricks": "txartatutako harribeltzezko adreiluak",
  "block.minecraft.polished_blackstone_brick_slab": "txartatutako harribeltzezko adreiluzko lauza",
  "block.minecraft.polished_blackstone_brick_stairs": "txartatutako harribeltzezko adreiluzko eskailerak",
  "block.minecraft.cracked_polished_blackstone_bricks": "txartatutako harribeltzezko adreilu pitzatuak",
  "block.minecraft.respawn_anchor": "berragertze-lotura",
}
export const eu_es = items; 
